import { NodeConnection } from '../types/workflow';

/**
 * Check if a connection can be made optional.
 * A connection can only be optional if:
 * 1. The end node has multiple connections (2 or more)
 * 2. At least one other connection is required (to ensure end node can start)
 */
export const canMakeConnectionOptional = (
  connection: NodeConnection,
  allConnections: NodeConnection[]
): boolean => {
  // Find all connections to the same end node
  // Note: deleted connections should already be filtered out by the API
  const connectionsToEndNode = allConnections.filter(
    (conn) =>
      conn.end_node.id === connection.end_node.id
  );

  // Need at least 2 connections to make one optional
  if (connectionsToEndNode.length < 2) {
    return false;
  }

  // Check if there's at least one other required connection
  // (if we make this optional, there should still be a required one)
  const otherConnections = connectionsToEndNode.filter(
    (conn) => conn.id !== connection.id
  );

  // If this connection is currently required, we need to ensure at least one required connection remains
  if (!connection.is_optional) {
    // Check if there's at least one other required connection
    const hasOtherRequired = otherConnections.some(
      (conn) => !conn.is_optional
    );
    
    // Need at least one non-optional (required) connection to remain
    // If all other connections are optional, we can't make this one optional
    // (at least one required connection must always remain for the end node to start)
    if (!hasOtherRequired) {
      return false;
    }
    
    // We can make this optional because at least one other required connection exists
    return true;
  }

  // If this connection is already optional, it can always be made required
  // (making required is always allowed)
  return true;
};

